import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'

@customElement('ep-absolute-time')
export class EPAbsoluteTime extends LitElement {

  @property({ attribute: 'datetime', reflect: true })
  datetimeString: string = new Date().toISOString();

  @property({ attribute: 'date-style', reflect: true })
  dateStyle: Intl.DateTimeFormatOptions['dateStyle'] = 'short';

  @property({ attribute: 'time-style', reflect: true })
  timeStyle: Intl.DateTimeFormatOptions['timeStyle'] = 'short';

  @property({ attribute: 'day-period', reflect: true })
  dayPeriod: Intl.DateTimeFormatOptions['dayPeriod'];

  get datetime(): Date {
    return new Date(this.datetimeString);
  }

  render() {
    const dtf = new Intl.DateTimeFormat('en-US', {
      dateStyle: this.dateStyle,
      timeStyle: this.timeStyle,
      dayPeriod: this.dayPeriod,
      // TODO: add more options?
    });

    return html`${dtf.format(this.datetime)}`;
  }

  static styles = css`
    :host {
      display: inline;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-absolute-time': EPAbsoluteTime
  }
}
